import api from "../lib/axios";

// fetch event data (no token needed)
export const getEventData = async (eventId, token) => {
  const res = await api.get(`/event/getEvent/${eventId}`, {
    timeout: 15000,
    retryOnTemporaryError: true,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const getEventId = async (slug) => {
  const res = await api.get(`/site/getEventId/${slug}`, {
    timeout: 15000,
    retryOnTemporaryError: true,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

export const updateSiteForEvent = async (eventId, token, data) => {
  const res = await api.post(
    `/event/updateSiteForEvent/${eventId}`,
    { data: data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const updateSiteSlugForEvent = async (eventId, token, slug) => {
  const res = await api.post(
    `/event/updateSiteSlugForEvent/${eventId}`,
    { slug: slug },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const updateEventLogo = async (eventId, token, logoFile) => {
  const formData = new FormData();
  formData.append("logo", logoFile);

  return api.put(`/event/updateEventLogo/${eventId}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    transformRequest: [(data) => data], // IMPORTANT: don't JSON.stringify FormData
  });
};

export const updateEventDataFromSite = async (token, eventData) => {
  return api.put(
    `/event/updateFromSite/${eventData?.id}`,
    { eventData },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateTicketPositionForEvent = async (eventId, token, data) => {
  const res = await api.put(
    `/event/ticket/position/${eventId}`,
    { data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const getAllEvents = async (token) => {
  const res = await api.get(`/event/getAllEvents`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const getAllEventsForUser = async (params) => {
  const res = await api.get(`/event/getAllEvents`, {
    params,
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "ngrok-skip-browser-warning": "true",
    },
  });
  return res;
};

export const getEventSlug = async (eventId, token) => {
  const res = await api.post(
    `/event/getSlug/${eventId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const getEventCategory = async (token) => {
  const res = await api.get(`/event/getEventCategory`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const createEvent = async (token, formData) => {
  const res = await api.post(`/event/createEvent`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    transformRequest: [(data) => data],
  });
  return res;
};

export const updateEvent = async (eventId, token, formData) => {
  const res = await api.put(`/event/updateEvent/${eventId}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    transformRequest: [(data) => data],
  });
  return res;
};

export const getWhatsappMessageType = async (eventId) => {
  const res = await api.get(`/event/whatsapp-message-type/${eventId}`);
  return res;
};

export const updateWhatsappMessageType = async (eventId, type) => {
  const res = await api.put(`/event/whatsapp-message-type/${eventId}`, { type });
  return res;
};

export const getWhatsappCategorySettings = async (eventId) => {
  const res = await api.get(`/event/whatsapp-category-settings/${eventId}`);
  return res;
};

export const updateWhatsappCategorySettings = async (eventId, settings) => {
  const res = await api.put(`/event/whatsapp-category-settings/${eventId}`, { settings });
  return res;
};

export const searchPlace = async (query, sessiontoken) => {
  const res = await api.get(`/event/searchPlace`, {
    params: { query, sessiontoken },
  });
  return res;
};

export const getPlaceDetails = async (placeId, sessiontoken) => {
  const res = await api.get(`/event/getPlaceDetails`, {
    params: { placeId, sessiontoken },
  });
  return res;
};

export const updateEvent2 = async (eventId, token, formData) => {
  const res = await api.put(`/event/updateEvent/${eventId}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "ngrok-skip-browser-warning": "true",
    },
    transformRequest: [(data) => data],
  });
  return res;
};

export const deleteEvent = async (eventId) => {
  const res = await api.delete(`/event/deleteEvent/${eventId}`);
  return res;
};
